import { Expose, Transform } from 'class-transformer';
import cuid from 'cuid';
export class ElementOptions {
  @Expose()
  @Transform(() => cuid())
  id!: string;

  @Expose()
  label!: string;
}
